// The LayoutShiftAttribution API is returning the numbers on physical dimension
export function convertPhysicalToLogicalResolution(rect) {
  if (typeof window.devicePixelRatio !== 'number') {
    return rect;
  }
  if (window.devicePixelRatio === 1) {
    return rect;
  }

  // eslint-disable-next-line compat/compat
  return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function createPerformanceObserver({
  onLayoutShift
}) {
  if (!window || typeof window.PerformanceObserver !== 'function') {
    return null;
  }
  const performanceObserverCallback = entries => {
    for (const entry of entries.getEntries()) {
      if (entry.entryType === 'layout-shift') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const changedRects = entry.sources.reduceRight((acc, attr) => {
          acc.push({
            rect: convertPhysicalToLogicalResolution(attr.currentRect),
            previousRect: convertPhysicalToLogicalResolution(attr.previousRect),
            node: attr.node
          });
          return acc;
        }, []);
        onLayoutShift({
          time: entry.startTime,
          changedRects
        });
      }
    }
  };
  const observer = new PerformanceObserver(performanceObserverCallback);
  return observer;
}
export default createPerformanceObserver;